import {
  Link,
  Routes,
  Route,
  useNavigate,
  useLocation,
} from 'react-router-dom';
import ChangePassword from './ChangePassword';
import M from 'materialize-css';
import { useEffect } from 'react';
import OtherSettings from './OtherSettings';
import DataExport from './DataExport.tsx';
import ChangeUserEmail from './ChangeUserEmail.js';
import queryHooks from '../../common/queryHooks/index.ts';

const SettingsPage = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const { data: user } = queryHooks.user.useReadOneById();

  useEffect(() => {
    M.Tabs.init(document.querySelectorAll('.tabs'));

    return () =>
      document
        .querySelectorAll('.tabs')
        .forEach(el => M.Tabs.getInstance(el)?.destroy());
  }, [pathname]);

  //update tab position on page refresh
  useEffect(() => {
    const route = pathname.split('/').pop();
    document
      .querySelectorAll('li>a')
      .forEach(el => el?.classList.remove('active'));
    const el = document.querySelector(`#${route}>a`);
    el?.classList.add('active');
  }, [pathname]);

  return (
    <div>
      <div className="row" style={{ marginTop: '40px' }}>
        <div className="col s12">
          <ul id="settings-tabs" className="tabs">
            <li
              id="changepassword"
              className="tab col"
              onClick={() => navigate('/settings/changepassword')}
            >
              <Link href="#password" to="/settings/changepassword">
                Change Password
              </Link>
            </li>
            <li
              id="changeuseremail"
              className="tab col"
              onClick={() => navigate('/settings/changeuseremail')}
            >
              <Link href="#username" to="/settings/changeuseremail">
                Change User Email
              </Link>
            </li>
            <li
              id="othersettings"
              className="tab col"
              onClick={() => navigate('/settings/othersettings')}
            >
              <Link href="#other" to="/settings/changepassword">
                Other Settings
              </Link>
            </li>
            <li
              id="export"
              className="tab col"
              onClick={() => navigate('/settings/export')}
            >
              <Link href="#export" to="/settings/export">
                Data Export
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="row">
        <Routes>
          <Route
            path="/changeuseremail"
            element={<ChangeUserEmail user={user} />}
          />
          <Route path="/changepassword" element={<ChangePassword />} />
          <Route
            path="/othersettings"
            element={<OtherSettings user={user} />}
          />
          <Route path="/export" element={<DataExport />} />
        </Routes>
      </div>
    </div>
  );
};

export default SettingsPage;
